import React from 'react'
import { CustomPasswordLinearProgress } from './StyledComponents'
import { useTranslation } from 'react-i18next';

const ProgressPassword = (props) => {
    const {t} = useTranslation()

    const regexes = [
        /^(?=.{1,})/,  // Not blank
        /^(?=.{8,})/,  // At least 8 characters
        /^(?=.*[A-Z])/, // At least one uppercase letter
        /^(?=.*[!@#$%^&*])/, // At least one special character
    ];

    const calculateStrength = () => {
        const strength = regexes.reduce((score, regex) => {
            return score + (regex.test(props.value) ? 1 : 0);
        }, 0);
        return Math.min(Math.ceil((strength / regexes.length) * 100), 100);
    };

    const getStrengthLabel = (strength) => {
        if (strength <= 25) {
            return t('navbar.login-options.very-weak');
        } else if (strength <= 50) {
            return t('navbar.login-options.weak');
        } else if (strength <= 75) {
            return t('navbar.login-options.normal');
        } else {
            return t('navbar.login-options.strong');
        }
    };

    const strength = calculateStrength();
    const strengthLabel = getStrengthLabel(strength);

    return (
        <div>
            <p>{t('navbar.login-options.password-strength')}: <span className='text-[#757575]'>{strengthLabel}</span></p>
            <CustomPasswordLinearProgress variant='determinate' value={calculateStrength()} />
        </div>
    )
}

export default ProgressPassword